import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { Box } from '@fhs-legacy/universal-components';
import { ServiceMode } from 'state/order';
import { focusableLabeledA11yProps } from 'utils/accessibility/focusable-labeled-props';

import { StyledText } from './styled';
import { ISubheadingText } from './types';

export const SubheadingText = ({ name, pickupTime, serviceMode }: ISubheadingText) => {
  const { formatMessage } = useIntl();

  return useMemo(() => {
    if (serviceMode === ServiceMode.EAT_IN) {
      const line1 = formatMessage({ id: 'orderConfirmationCheckoutInstructionDineIn' }, { name });
      const line2 = formatMessage({ id: 'orderConfirmationCheckoutInstructionDineInSubtitle' });
      const a11yLabel = `${line1} ${line2}`;
      return (
        <Box {...focusableLabeledA11yProps(a11yLabel)}>
          <StyledText importantForAccessibility="no-hide-descendants">
            <StyledText fontWeight="bold">{line1}</StyledText>
            <StyledText maxW={'450'}>{line2}</StyledText>
          </StyledText>
        </Box>
      );
    }
    if (serviceMode === ServiceMode.DRIVE_THRU) {
      const a11yLabel = formatMessage({ id: 'driveThruPickupInstructions' }, { name });
      return (
        <Box {...focusableLabeledA11yProps(a11yLabel)}>
          <StyledText importantForAccessibility="no-hide-descendants">{a11yLabel}</StyledText>
        </Box>
      );
    }
    if (serviceMode === ServiceMode.CURBSIDE) {
      const a11yLabel = formatMessage({ id: 'curbsideInstructionsText' }, { time: pickupTime });
      return (
        <Box {...focusableLabeledA11yProps(a11yLabel)}>
          <StyledText importantForAccessibility="no-hide-descendants">{a11yLabel}</StyledText>
        </Box>
      );
    }
    if (serviceMode === ServiceMode.PICKUP_WINDOW) {
      const a11yLabel = formatMessage({ id: 'pickupWindowInstructionsText' });
      return (
        <Box {...focusableLabeledA11yProps(a11yLabel)}>
          <StyledText importantForAccessibility="no-hide-descendants" fontWeight="bold">
            {a11yLabel}
          </StyledText>
        </Box>
      );
    }

    const line1 = formatMessage({ id: 'orderConfirmationCheckoutInstruction' }, { name });
    const line2 = formatMessage({ id: 'noChangesToOrderTime' });
    const a11yLabel = `${line1} ${line2}`;
    return (
      <Box {...focusableLabeledA11yProps(a11yLabel)}>
        <StyledText importantForAccessibility="no-hide-descendants">
          <StyledText fontWeight="bold">{line1}</StyledText>{' '}
          {line2}
        </StyledText>
      </Box>
    );
  }, [formatMessage, name, pickupTime, serviceMode]);
};
